import { useLocalStorageState } from 'ahooks'
import { SetState } from 'ahooks/lib/createUseStorageState'

import { mergePropertiesWhenDefined } from '@/utils/commons'

export enum Version {
  v1 = 'v1',
  v2 = 'v2',
  v3 = 'v3',
}

export function useLocalStorage<T>(
  componentId: string,
  workspaceId: string,
  defaultValue?: T | SetState<T>,
  version?: Version
): [T, (value: T) => void] {
  const key = `${workspaceId}_${componentId}_${version || Version.v1}`
  const [localStorageValue, setValue] = useLocalStorageState<T>(key, {
    defaultValue,
  })

  const value =
    typeof localStorageValue === 'object' && typeof defaultValue === 'object'
      ? mergePropertiesWhenDefined<T>(localStorageValue, defaultValue)
      : typeof localStorageValue !== 'undefined'
        ? localStorageValue
        : defaultValue

  return [value as T, setValue]
}
